import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeTableauLibre } from '../models/TypeTableauLibre';
import { TR } from '../models/TR';
import { Step3 } from '../../../../shared/models/component-messages/mapaIN/step3';
import { ArrayPopTools } from '../../../../shared/services/array-pop-tools';
@Component({
  selector: 'app-type-tableau-libre',
  templateUrl: './type-tableau-libre.component.html'
})
export class TypeTableauLibreComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeTableauLibre';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() tabCarLibre: TypeTableauLibre;

  public step3 = new Step3();

  constructor() { }

  public ngOnInit() {
    
    if(this.tabCarLibre == undefined || this.tabCarLibre == null ||(this.tabCarLibre.tr && this.tabCarLibre.tr[0].td.length === 0)) {
      this.tabCarLibre = new TypeTableauLibre();
      }
  }


  addtR(){
    if(!this.tabCarLibre.tr) {
			this.tabCarLibre.tr = [];
		}
		this.tabCarLibre.tr.push(new TR());
	}
  
  removetR(i){
    ArrayPopTools.pop(this.tabCarLibre.tr, i, this.parentForm, this.getUid());
	}
  

  
  getUid() {    return this.uid + '_SepSep_' + this.current_uid;
}
  
  
}

